import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_nomina, imss_ } from '../../../../../../Constants/Constants';
import { ArrayJsonIMSS } from '../../../Helpers/JsonToOneLevel';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const IMSS = ({ id, permisos }) => {
    const [ seguros, setSeguros ] = useState( null );
    useEffect(() => {
        axiosSeguros();
    }, []);

    const axiosSeguros = () => {
        axios.get( `${servicios_grupogack_nomina}/imss/getall/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setSeguros( ArrayJsonIMSS(respuesta.data.dataResponse) );
                        break;
                    case 404: //No hay datos para mostrar
                        setSeguros([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    return (
        <div id={ id }>
            { seguros ?
                <DataTableService id={id} title={ imss_ } permisos={permisos}
                    columns={[
                        { field: "fechainiTab", title: "Fecha Inicial" },
                        { field: "fechafinTab", title: "Fecha Final" },
                        { field: "enfmatpat", title: "% Enfermedades Maternidad Patrón", cellStyle: rowData => ({ textAlign:'right'}), headerStyle: { textAlign:'right'} },
                        { field: "enfmatobr", title: "% Enfermedades Maternidad Obrera", cellStyle: rowData => ({ textAlign:'right'}), headerStyle: { textAlign:'right'}},
                        { field: "pat", title: "Tope Cuotas Obrero-Patronal (MXN)", cellStyle: rowData => ({ textAlign:'right'}), headerStyle: { textAlign:'right'} },
                        { field: "sueldo", title: "Factor Aplicable al Sueldo", cellStyle: rowData => ({ textAlign:'right'}), headerStyle: { textAlign:'right'}},
                    ]}
                    data={ seguros } />
                :
                <SpinnerOval />
            }
        </div>
    );
};

export default IMSS;